import { Controller } from "@hotwired/stimulus"

// 会場 select の選択中要素から郵便番号/住所をヒント表示する
export default class extends Controller {
  static targets = ["select", "hint"]

  connect() {
    this.update()
  }

  update() {
    const select = this.hasSelectTarget ? this.selectTarget : this.element.querySelector("select")
    if (!select) return

    const opt = select.options[select.selectedIndex]
    let hint = ""
    if (opt && opt.value) {
      const postal = opt.dataset.postalCode || ""
      const address = opt.dataset.address || ""
      const parts = []
      if (postal) parts.push(`〒${postal}`)
      if (address) parts.push(address)
      hint = parts.join(" ")
    }

    // NOTE: タイトル属性を常に同期（狭いフォームではこれがヒントとして使われる）
    select.title = hint

    if (this.hasHintTarget) {
      this.hintTarget.textContent = hint
    }
  }
}
